"use client";

import { forwardRef, ReactNode, useCallback, useState } from 'react';
// import { Box } from '@fastlooptech/layout-components';
import { InputWrapProps, InputWrap } from '../InputWrap/InputWrap';
import { Box } from '@/layouts/LayoutComponents';

export type InputCheckboxProps<V> = Omit<InputWrapProps, 'children' | 'htmlFor' | 'label'> & {
  'data-test-id'?: string;
  /**
   * The className of the input.
   * @type string
   * @optional
   */
  className?: string;
  /**
   * The on change function.
   * @type (checked: boolean) => void;
   */
  onChange?: (checked: boolean) => void;
  /**
   * The on blur function.
   * @type (checked: boolean) => void;
   */
  onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  /**
   * The id of the input.
   * @type string
   * @required
   */
  id: string;
  /**
   * The name of the input.
   * @type string
   * @required
   */
  name: string;
  /**
   * The value of the input.
   * @type V
   * @required
   */
  value: V;
  /**
   * The text of the checkbox label.
   * @type string | ReactNode
   * @required
   */
  label: string | ReactNode;
  /**
   * The boolean that determines if the input is disabled.
   * @type boolean
   * @optional
   * @default false
   */
  disabled?: boolean;
  /**
   * The boolean that determines if the input is checked.
   * @type boolean
   * @optional
   * @default false
   */
  checked?: boolean;
  /**
   * The height of the option.
   * @type number
   * @optional
   * @default 24
   */
  height?: number;
};

function InputCheckboxInner<V>(props: InputCheckboxProps<V>, ref: React.ForwardedRef<HTMLInputElement>) {
  const [checked, setChecked] = useState<InputCheckboxProps<V>['checked']>(props.checked || props.value === true);

  const handleSetCheck = useCallback(
    (target: HTMLInputElement) => {
      setChecked(target.checked);
      if (!!props.onChange) {
        props.onChange(target.checked);
      }
    },
    [props]
  );

  return (
    <InputWrap
      assistive={props.assistive}
      required={props.required}
      width={props.width}
      disabled={props.disabled}
      data-test-id={props['data-test-id'] + '-wrapper'}
      className={props.className}
    >
      <Box
        vAlignContent="center"
        hAlignContent="left"
        data-test-id={props['data-test-id'] + '-option'}
        data-value={props.id}
        className="relative group"
        height={props.height}
        grow
      >
        <input
          title={props.name}
          type="checkbox"
          id={props.id}
          name={props.name}
          value={`${props.value}`}
          checked={props.checked || checked}
          disabled={props.disabled}
          data-test-id={props['data-test-id']}
          onChange={e => handleSetCheck(e.target)}
          onBlur={props.onBlur}
          className="opacity-0 absolute h-3 w-3 cursor-pointer disabled:cursor-not-allowed peer"
          ref={ref}
        />
        {/* <Box vAlignContent="center" hAlignContent="left" grow className={classNames('py-1')}>
          <CheckboxSquare
            id={props.id}
            checked={props.checked || checked}
            disabled={props.disabled}
            data-test-id={props['data-test-id'] + '-icon'}
            assistive={props.assistive}
          />
          {typeof props.label === 'string' ? (
            <Body
              size="s"
              className={classNames('flex text-inherit select-none pl-1', props.classNameLabel, {
                'cursor-pointer text-interactive-black': !props.disabled,
                'cursor-not-allowed text-base-grey': props.disabled,
              })}
            >
              {props.label}
            </Body>
          ) : (
            <label
              htmlFor={props.id + '-' + props.value}
              data-test-id={props['data-test-id'] + '-label'}
              className={classNames('flex max-w-fit', props.classNameLabel)}
            >
              {props.label}
            </label>
          )}
        </Box> */}
      </Box>
    </InputWrap>
  );
}

const InputCheckboxWithRef = forwardRef(InputCheckboxInner);

type InputCheckboxWithRefProps<V> = InputCheckboxProps<V> & {
  ref?: React.Ref<HTMLInputElement>;
};

export function InputCheckbox<V>({ ref, ...props }: InputCheckboxWithRefProps<V>) {
  return <InputCheckboxWithRef ref={ref} {...props} />;
}

// interface CheckboxSquareProps {
//   'data-test-id'?: string;
//   id: string;
//   checked?: boolean;
//   disabled?: boolean;
//   /**
//    * The assistive text input.
//    * @type InputsNS.Assistive[]
//    * @default { message: "", type: "informative" }[]
//    * @optional
//    */
//   assistive?: InputsNS.Assistive[];
//   /**
//    * The boolean that determines if the checkbox is indeterminate.
//    * @type boolean
//    * @optional
//    * @default false
//    */
//   indeterminate?: boolean;
// }

// export function CheckboxSquare(props: CheckboxSquareProps) {
//   const checkboxStyle = useCheckboxStyle(
//     props.assistive?.filter(assistive => {
//       if (props.assistive && props.assistive?.length === 1) return props.assistive;
//       return assistive.type !== InputsNS.StatusType.Informative;
//     })[0].type,
//     props.disabled
//   );

//   return (
//     <Box
//       data-test-id={props['data-test-id']}
//       id={props.id}
//       aria-checked={!!props.checked}
//       aria-label={props.indeterminate ? 'indeterminate' : ''}
//       aria-disabled={props.disabled}
//       className={classNames(
//         'border-[1.5px] rounded-4 group-focus-within:outline group-focus-within:outline-[1.5px] group-focus-within:outline-offset-2',
//         checkboxStyle,
//         {
//           '!bg-base-grey': props.disabled && props.checked,
//           'bg-transparent': !props.checked,
//         }
//       )}
//       vAlignContent="center"
//       hAlignContent="center"
//       height={spaceUnit * 3}
//       basis={spaceUnit * 3}
//     >
//       <Icons.Check
//         id="checkbox-check"
//         size="s"
//         className={classNames({
//           'fill-base-white': props.checked,
//           'fill-transparent': !props.checked,
//         })}
//       />
//     </Box>
//   );
// }
